import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import React, { useMemo, useState } from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';
import { SanitizeHTML } from '@/utils/SanitzeHTML.comp.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { splitQuotedHistory } from '@/views/emails/util/splitQuotedHistory.util.ts';

interface CollapsibleEmailProps {
  rawHtml: string;
}

export const CollapsibleEmail: React.FC<CollapsibleEmailProps> = ({ rawHtml }) => {
  const { t } = useTranslationWithPrefix('views.emails.threadEmails.email.body');
  const [open, setOpen] = useState(false);

  const { history, message } = useMemo(() => splitQuotedHistory(rawHtml), [rawHtml]);

  return (
    <Stack spacing={1}>
      <SanitizeHTML html={message} />
      {history && (
        <Tooltip title={open ? t('hideHistory') : t('showHistory')}>
          <ButtonBase
            aria-expanded={open}
            onClick={() => setOpen(prev => !prev)}
            sx={{
              '&:hover': {
                background: themeColors.stroke,
              },
              alignSelf: 'flex-start',
              background: themeColors.stroke60,
              borderRadius: 2,
              px: 1,
            }}
          >
            <MoreHorizIcon />
          </ButtonBase>
        </Tooltip>
      )}
      {open && <SanitizeHTML html={history} />}
    </Stack>
  );
};
